export default "__VITE_ASSET__DiEggZRA__"